import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonVariant } from "components/base/Button";
import ModalTransferir from "./ModalTransferir";
import { ContaType } from "services/contaService";
import { useContas } from "hooks/useContas";

interface BotaoTransferirProps {
    conta: ContaType;
    size?: "sm" | "lg";
    variant?: ButtonVariant;
    title?: string;
    showText?: boolean;
}

const BotaoTransferir: React.FC<BotaoTransferirProps> = ({
    conta,
    size = "sm",
    variant = "outline-info",
    title = "Transferir",
    showText = false
}) => {
    const [showModal, setShowModal] = useState(false);
    const contasQuery = useContas();

    const handleClick = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <Button
                variant={variant}
                size={size}
                onClick={handleClick}
                title={title}
            >
                <FontAwesomeIcon icon={faExchangeAlt} className={showText ? "me-2" : ""} />
                {showText && "Transferir"}
            </Button>

            <ModalTransferir
                show={showModal}
                onHide={handleClose}
                contaOrigem={conta}
                contas={contasQuery.data || []}
            />
        </>
    );
};

export default BotaoTransferir; 